<script>
import Modal from '../../Modal.vue';

export default {
  components: {
    Modal,
  },
  props: {
    title: {
      type: String,
      default: 'This is a title',
    },
    description: {
      type: String,
      default: 'This is your description',
    },
    confirmLabel: {
      type: String,
      default: 'Yes',
    },
    loadingLabel: {
      type: String,
      default: '',
    },
    cancelLabel: {
      type: String,
      default: 'No',
    },
  },
  data: () => ({
    show: false,
    isConfirming: false,
    loadingDotCount: 1,
    loadingAnimationTimer: undefined,
    onConfirm: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  computed: {
    confirmButtonLabel() {
      if (!this.isConfirming) return this.confirmLabel;

      return this.loadingLabel || this.confirmLabel;
    },
  },

  beforeDestroy() {
    this.stopLoadingAnimation();
  },

  methods: {
    showConfirmation({ onConfirm } = {}) {
      this.show = true;
      this.onConfirm = onConfirm;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    async confirm() {
      if (this.isConfirming) return;

      if (this.onConfirm) {
        this.isConfirming = true;
        this.startLoadingAnimation();
        try {
          await this.onConfirm();
        } catch (error) {
          this.resolvePromise(false);
          this.onConfirm = undefined;
          this.show = false;
          return;
        } finally {
          this.stopLoadingAnimation();
          this.isConfirming = false;
        }
      }

      this.resolvePromise(true);
      this.onConfirm = undefined;
      this.show = false;
    },

    cancel() {
      if (this.isConfirming) return;

      this.resolvePromise(false);
      this.onConfirm = undefined;
      this.show = false;
    },
    startLoadingAnimation() {
      this.loadingDotCount = 1;
      this.stopLoadingAnimation();
      this.loadingAnimationTimer = setInterval(() => {
        this.loadingDotCount =
          this.loadingDotCount === 3 ? 1 : this.loadingDotCount + 1;
      }, 400);
    },
    stopLoadingAnimation() {
      if (!this.loadingAnimationTimer) return;

      clearInterval(this.loadingAnimationTimer);
      this.loadingAnimationTimer = undefined;
    },
  },
};
</script>

<template>
  <Modal :show.sync="show" :on-close="cancel">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header :header-title="title" :header-content="description" />
      <div class="flex flex-row justify-end gap-2 py-4 px-6 w-full">
        <woot-button variant="clear" :disabled="isConfirming" @click="cancel">
          {{ cancelLabel }}
        </woot-button>
        <woot-button :is-loading="isConfirming" @click="confirm">
          {{ confirmButtonLabel }}
          <span
            v-if="isConfirming"
            aria-hidden="true"
            class="inline-block text-left min-w-[1.5ch]"
          >
            <span
              v-for="index in 3"
              :key="index"
              :class="{ 'opacity-0': loadingDotCount < index }"
              >.
            </span>
          </span>
        </woot-button>
      </div>
    </div>
  </Modal>
</template>
